import datos from "src/services/datos";
import "src/services/styles/sweetAlert.css";
import Swal from "sweetalert2";
import { esArray } from "src/general_components/functionEsArray";
import { getMetadatos } from "./MetadatoData";
import { headers } from "src/services/header";
import { endpoints } from "src/configs/config_endpoints";
import { requestService } from "src/services/requestService";

const ordenarPorLoteYId = (array) => {
  // Obtener todos los lotes únicos
  const lotesUnicos = Array.from(new Set(array.map(obj => obj.lote)));

  // Asignar un color alternativo a cada lote único
  const coloresPorLote = {};
  lotesUnicos.forEach((lote, index) => {
    coloresPorLote[lote] = index % 2 === 0 ? 'blanco' : 'Contenidos'; // Aquí puedes ajustar los colores según tus necesidades
  });

  // Ordenar por lote y luego por id
  const arrayOrdenado = array.slice().sort((a, b) => {
    if (a.lote === b.lote) {
      return a.id - b.id; // Si los lotes son iguales, se ordena por id
    } else {
      return a.lote - b.lote; // Si los lotes son diferentes, se ordena por lote
    }
  });

  // Agregar la propiedad color a cada objeto en el array ordenado
  arrayOrdenado.forEach(obj => {
    obj.color = coloresPorLote[obj.lote];
  });

  return arrayOrdenado;
};

export const getLoteMaximo = async (id_caja) => {
  const objectContenidos = new datos("contenidos");
  const estructura = { id_caja: id_caja, };

  const response = await objectContenidos.getLote(estructura);

  let lote = 1;
  if (response.status === 'true') {
    lote = response?.wsResponse?.lote_maximo;
    lote = parseInt(lote) + 1;
  }


  return lote;

};

export const getContenidos = async () => {
  await getLoteMaximo();
  const objectContenidos = new datos("contenidos");
  objectContenidos.addCondition("contenidos", "id_cajas", "id_cajas", "=");
  objectContenidos.join("tipo_contenidos", "id", "id_tipo_contenidos");
  objectContenidos.join("contenidos_metadatos", "id_contenidos", "id", "=");
  objectContenidos.join("metadatos", "id_tipo_contenidos", "id", "=");
  const response = await objectContenidos.get();
  const cont = response.wsResponse.contenidos;
  if (Array.isArray(cont)) {
    var arr = cont;
  } else if (typeof cont === "undefined") {
    arr = [];
  } else {
    arr = [cont];
  }
  return arr;
};

export const postContenidos = async (contenidos) => {
  const { id, id_cajas, id_tipo_contenidos, meta_datos, lote, img } = contenidos;

  const imagen = img ? img.replace(/^data:image\/[a-z]+;base64,/, "") : false;
  // Filtrar los meta_datos válidos
  const metaDatosFiltrado = meta_datos.filter(
    (item) => item.valor !== undefined && item.valor !== "" && item.valor !== null
  );

  // Construir el objeto data dinámicamente
  const data = {
    id: id,
    id_cajas: id_cajas,
    id_tipo_contenidos: id_tipo_contenidos,
    meta_datos: metaDatosFiltrado,
    lote: lote || "1",
    ...(imagen ? { imagen } : {}) // Añadir "imagen" solo si está presente
  };

  const contenidosInsert = new datos("contenidos");
  const response = await contenidosInsert.contenidosCreate(data);

  return response;
};


// Shared helper: strips the data-URL prefix from a base64 string
export const stripBase64Prefix = (base64) =>
  base64 ? base64.replace(/^data:[^;]+;base64,/, "") : base64;

export const postContenidosArray = async (contenidosArray) => {
  // Iterar sobre el array de contenidos para procesar cada elemento
  const dataToPost = contenidosArray.map((contenido) => {
    const { id, id_cajas, id_tipo_contenidos, meta_datos, lote, img } = contenido;

    // Transformar la imagen (eliminar prefijo Base64 si existe)
    const imagen = img ? stripBase64Prefix(img) : undefined;

    // Filtrar los meta_datos válidos
    const metaDatosFiltrado = meta_datos.filter(
      (item) => item.valor !== undefined && item.valor !== "" && item.valor !== null
    );

    // Construir el objeto transformado
    return {
      id: id,
      id_cajas: id_cajas,
      id_tipo_contenidos: id_tipo_contenidos,
      meta_datos: metaDatosFiltrado,
      lote: lote || "1",
      ...(imagen ? { imagen } : {}) // Añadir "imagen" solo si está presente
    };
  });

  // Enviar el lote completo
  const contenidosInsert = new datos("contenidos");
  const response = await contenidosInsert.contenidosCreate(dataToPost);

  return response;
};

// Crea contenidos de forma secuencial (uno por llamada al backend).
// Devuelve array de { slot_index, contenidoId, error }.
export const postContenidosMasivo = async (slots) => {
  const results = [];
  for (let i = 0; i < slots.length; i++) {
    const { id, id_cajas, id_tipo_contenidos, meta_datos, lote } = slots[i];
    const metaDatosFiltrado = (meta_datos || []).filter(
      (item) => item.valor !== undefined && item.valor !== "" && item.valor !== null
    );
    const data = {
      id: id || "",
      id_cajas,
      id_tipo_contenidos,
      meta_datos: metaDatosFiltrado,
      lote: lote || "1",
    };
    try {
      const contenidosInsert = new datos("contenidos");
      const response = await contenidosInsert.contenidosCreate(data);
      if (response?.status === "true") {
        const contenidoId =
          response?.wsResponse?.id ||
          response?.wsResponse?.contenido?.id ||
          response?.wsResponse?.contenidos?.id ||
          null;
        results.push({ slot_index: i, contenidoId, error: null });
      } else {
        results.push({ slot_index: i, contenidoId: null, error: response?.message || "Error al crear contenido" });
      }
    } catch (err) {
      results.push({ slot_index: i, contenidoId: null, error: err?.message || "Error desconocido" });
    }
  }
  return results;
};


export const deleteContenido = async (id) => {
  let status = false;
  await Swal.fire({
    title: "Esta seguro de que desea eliminar este Contenido?",
    text: "Si sigue adelante, no se podran revertir los cambios!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, quiero eliminarlo!",
    cancelButtonText: "No, no estoy seguro!",
    customClass: {
      container: "my-swal-delete",
    },
  }).then(async (result) => {
    if (result.isConfirmed) {
      const userData = new datos("contenidos");
      let data = {
        id: id,
      };
      const response = await userData.delete(data);

      if (response.status === "true") {
        status = true;
        await Swal.fire({
          title: "Eliminado!",
          text: "El contenido ha sido eliminado exitosamente",
          icon: "success",
          customClass: {
            container: "my-swal-delete",
          },
        });
      } else {
        await Swal.fire({
          customClass: {
            container: "my-swal-delete",
          },
          icon: "error",
          title: "Oops...",
          text: response.message,
        });
      }
    }
  });
  return status;
};

export const getContenidosPaginated = async (limit, offset, conditions) => {

  const { id_caja, clienteName, contenidos_coincidencias, mostrarContenidosCoincidentes } = conditions;
  const objectContenidos = new datos("contenidos");
  objectContenidos.addCondition("contenidos", "id_cajas", id_caja, "=");
  if (mostrarContenidosCoincidentes && contenidos_coincidencias) {
    objectContenidos.addCondition("contenidos", "id", contenidos_coincidencias, "in");
  }
  objectContenidos.join("tipo_contenidos", "id", "id_tipo_contenidos");
  objectContenidos.join("contenidos_metadatos", "id_contenidos", "id", "=");
  objectContenidos.join("cajas", "id", "id_cajas");
  objectContenidos.innerJoinTables("metadatos", "contenidos_metadatos", "id", "id_metadatos", "=")
  objectContenidos.join(
    "estados_contenidos",
    "id",
    "id_estados_contenidos",
    "="
  );
  objectContenidos.addLimitCondition(limit, offset);
  const response = await objectContenidos.get();

  if (!response) {
    return { data: [], total_records: 0 };
  }

  if (response.wsResponse.contenidos) {
    const contenidosData = esArray(response.wsResponse.contenidos);
    let maxLoteValue = 0; // Variable para almacenar el valor máximo del lote
    for (let i = 0; i < contenidosData.length; i++) {
      let texto = "";
      let esArrayContenidosMetadatos = Array.isArray(
        contenidosData[i].relations.contenidos_metadatos
      );
      contenidosData[i].tipo_contenidos = contenidosData[i]?.relations?.tipo_contenidos?.detalle;
      contenidosData[i].cliente = clienteName;
      contenidosData[i].isRowSelectable = true;
      contenidosData[i].id_cuentas_localizaciones = contenidosData[i]?.relations?.cajas?.id_cuentas_localizaciones;
      const loteValue = contenidosData[i].lote; // Obtén el valor del lote de cada objeto
      // Verifica si el valor del lote actual es mayor que el valor máximo encontrado hasta ahora
      if (loteValue > maxLoteValue) {
        maxLoteValue = loteValue; // Actualiza el valor máximo del lote
      }
      let listMetadatos = esArray(contenidosData[i]?.relations?.metadatos);
      if (esArrayContenidosMetadatos) {
        contenidosData[i].contenidos_metadatos =
          contenidosData[i]?.relations?.contenidos_metadatos ?
            contenidosData[i]?.relations?.contenidos_metadatos.map(
              (metadatos) => {
                let metadatoObtenido = listMetadatos.find((metadato) => metadato.id === metadatos.id_metadatos);
                let metadatoLabel = metadatoObtenido.label_form;
                texto = texto + " " + metadatoLabel + " : " + metadatos?.valor;
                return {
                  id: metadatos.id,
                  id_metadatos: metadatos.id_metadatos,
                  valor: metadatos?.valor,
                  label_grilla: metadatoObtenido.label_grilla,
                  metadato_label_form: metadatoObtenido.label_form,
                  metadato_valor: typeof metadatos?.valor === 'object' ? null : metadatos?.valor,
                };
              }
            ) : []
      } else {
        let arrayMetadato = esArray(contenidosData[i].relations.contenidos_metadatos);

        contenidosData[i].contenidos_metadatos =
          contenidosData[i]?.relations?.contenidos_metadatos ?
            arrayMetadato.map((metadatos) => {
              let metadatoObtenido = listMetadatos.find((metadato) => metadato.id === metadatos.id_metadatos);
              let metadatoLabel = metadatoObtenido.label_form;
              texto = texto + " " + metadatoLabel + " : " + metadatos?.valor;
              return {
                id: metadatos.id,
                id_metadatos: metadatos.id_metadatos,
                valor: metadatos?.valor,
                label_grilla: metadatoObtenido.label_grilla,
                metadato_label_form: metadatoObtenido.label_form,
                metadato_valor: typeof metadatos?.valor === 'object' ? null : metadatos?.valor,
              };
            }) : []
      }
      contenidosData[i].contenidos_metadatos_ordenados = texto === "" ? " Sin metadatos " : texto;
      contenidosData[i].estado = contenidosData[i].relations?.estados_contenidos?.detalle;
    }

    contenidosData.forEach((objeto) => {
      objeto.lote_mayor = maxLoteValue; // Añade la propiedad lote_mayor con el valor máximo
    });

    const contenidosDataOrdenadoPorLote = ordenarPorLoteYId(contenidosData);
    let result = {
      data: contenidosDataOrdenadoPorLote,
      total_records: response.wsResponse.total_records,
    };
    return result;
  } else {
    let result = {
      data: [],
      total_records: 0,
    };
    return result;
  }
};

export const getContenidosNotPaginated = async (conditions) => {
  const { id_caja, clienteName } = conditions;
  const objectContenidos = new datos("contenidos");
  objectContenidos.addCondition("contenidos", "id_cajas", id_caja, "=");
  objectContenidos.join("tipo_contenidos", "id", "id_tipo_contenidos");
  objectContenidos.join("contenidos_metadatos", "id_contenidos", "id", "=");
  objectContenidos.join("metadatos", "id_tipo_contenidos", "id", "=");
  objectContenidos.join(
    "estados_contenidos",
    "id",
    "id_estados_contenidos",
    "="
  );
  const response = await objectContenidos.get();

  if (response.wsResponse.contenidos) {
    const contenidosData = esArray(response.wsResponse.contenidos);
    let listMetadatos = JSON.parse(localStorage.getItem("siam-metadatos"));
    if (!listMetadatos) {
      listMetadatos = await getMetadatos();
    }
    for (let i = 0; i < contenidosData.length; i++) {
      let texto = "";
      let esArray = Array.isArray(
        contenidosData[i].relations.contenidos_metadatos
      );
      contenidosData[i].tipo_contenidos =
        contenidosData[i]?.relations?.tipo_contenidos?.detalle;
      contenidosData[i].cliente = clienteName;
      contenidosData[i].isRowSelectable = true;
      if (esArray) {
        contenidosData[i].contenidos_metadatos =
          contenidosData[i]?.relations?.contenidos_metadatos &&
          contenidosData[i]?.relations?.contenidos_metadatos.map(
            (metadatos) => {
              let metadatoObtenido = listMetadatos.metadatos.find(
                (metadato) => metadato.id === metadatos.id_metadatos
              );
              let metadatoLabel = metadatoObtenido.label_grilla;
              texto = texto + " " + metadatoLabel + " : " + metadatos?.valor;
              return {
                id: metadatos.id,
                id_metadatos: metadatos.id_metadatos,
                valor: metadatos?.valor,
              };
            }
          );
      } else {
        let arrayMetadato = [contenidosData[i].relations.contenidos_metadatos];
        contenidosData[i].contenidos_metadatos =
          contenidosData[i]?.relations?.contenidos_metadatos &&
          arrayMetadato.map((metadatos) => {
            let metadatoObtenido = listMetadatos.metadatos.find(
              (metadato) => metadato.id === metadatos.id_metadatos
            );
            let metadatoLabel = metadatoObtenido.label_grilla;
            texto = texto + " " + metadatoLabel + " : " + metadatos?.valor;
            return {
              id: metadatos.id,
              id_metadatos: metadatos.id_metadatos,
              valor: metadatos?.valor,
            };
          });
      }
      contenidosData[i].contenidos_metadatos_ordenados = texto;
      contenidosData[i].estado =
        contenidosData[i].relations?.estados_contenidos?.detalle;
    }

    return contenidosData;
  } else {
    let result = {
      data: [],
      total_records: 0,
    };
    return result.data;
  }
};

export const getContenidosRetiro = async (data) => {
  const contenidosRetiro = new datos("contenidos");
  const response = await contenidosRetiro.searchContenidos(data);

  return response;
};

export const movementContenidos = async (data) => {
  const contenidosMovement = new datos("contenidos");
  const response = await contenidosMovement.movementContenidos(data);

  return response;
};

function convertirSectoresAArray(objeto) {
  const sectores = objeto?.cuenta?.sectores?.sector;
  if (!sectores) return objeto;

  // Si solo hay un sector, lo convertimos en un array
  if (!Array.isArray(sectores)) {
    objeto.cuenta.sectores.sector = esArray(sectores);
  }

  return objeto;
}

export const updateContenidos = async (contenidos) => {
  const { id, id_cajas, id_tipo_contenidos, meta_datos, lote } = contenidos;
  let metaDatosCompletos = [...meta_datos];

  var metaDatosFiltrado = meta_datos.filter(
    (item) =>
      (item.valor === "undefined" ||
        item.valor === undefined ||
        item.valor === null ||
        item.valor === "") &&
      item.id !== ""
  );

  metaDatosCompletos = metaDatosCompletos.filter(
    (item) =>
      item.valor !== undefined &&
      item.valor !== null &&
      item.valor !== "" &&
      item.id_metadatos !== ""
  );
  metaDatosFiltrado.forEach(function (metadato, index) {
    metaDatosCompletos.push({ id: metadato.id, delete: "1" });
  });

  let data = [];
  data.id = id;
  data.id_tipo_contenidos = id_tipo_contenidos;
  data.id_cajas = id_cajas;
  data.lote = lote || "1";
  data.meta_datos = metaDatosCompletos;

  const contenidosUpd = new datos("contenidos");
  const response = await contenidosUpd.contenidosUpdate(data);

  return response;
};

export const getContenidosSearch = async (data) => {
  const contenidos = new datos("contenidos");
  const response = await contenidos.searchContenidosPrincipal(data);

  return response;
};

const eliminarValoresEntreParentesis = (cadena) => cadena.includes('(') ? cadena.replace(/\([^)]*\)/g, '').trim() : cadena;


export const getContenidosSearchPaginated = async (limit, offset, data, ordenamiento) => {
  let proceso_seleccionado = JSON.parse(localStorage.getItem("proceso_seleccionado"));
  if (Array.isArray(data)) {
    // eslint-disable-next-line no-unused-vars
    let data = {
      coincidencias: "1",
      eliminados: "0",
      search_params: {},
      limit: limit,
      offset: offset,
    };
  }
  const contenidos = new datos("contenidos");

  if (data.busqueda_simple) {

    const datos_search = {
      idLocalizaciones: data?.search_params?.busqueda_simple?.ids_cuentas_localizaciones ?? [],
      inputSearch: data?.search_params?.busqueda_simple?.data ?? '',
      soloCajas: data?.soloCajas ?? false,
      devuelveContenidos: data?.devuelveContenidos ?? false,
      busqueda_digitalizaciones: data?.busqueda_digitalizaciones ? "1" : "0",
    };

    if (data?.search_params?.ubicaciones) {
      datos_search.ubicaciones = data.search_params.ubicaciones;
    }

    if (data?.search_params?.cajas) {
      datos_search.cajas = data.search_params.cajas;
    }

    if (data?.search_params?.estados_cajas) {
      datos_search.estados_cajas = data.search_params.estados_cajas;
    }

    if (data?.search_params?.custom_query) {
      datos_search.custom_query = data.search_params.custom_query;
    }

    let response = await getContenidosPaginatedDashboard(limit, offset, datos_search);

    const data_array = agregarPropiedades(response.data, response.digitalizaciones_coincidencias);
    response.data = data_array;

    return response;

  } else {
    if (data.jerarquia) {
      try {
        const response = await contenidos.searchContenidosPrincipal(
          data,
          limit,
          offset,
          ordenamiento
        );

        if (response.wsResponse.cuentas) {
          var cuentas = esArray(response.wsResponse.cuentas.cuenta);
          if (response.wsResponse.id_contenidos) {
            if (Object.keys(response.wsResponse.id_contenidos?.id).length === 0) {
              var contenidosId = [];
            } else {
              contenidosId = esArray(response.wsResponse.id_contenidos.id);
            }
          }
          let cajasId = [];
          if (response.wsResponse.id_cajas) {
            cajasId = response.wsResponse.id_cajas.split(',').map(id => String(id));
          } else {
            cajasId = [];
          }

          localStorage.setItem('id_contenidos', contenidosId)
          if (cuentas) {
            var listCajasCont = [];
            // Bucle de cuentas
            for (let i = 0; i < cuentas.length; i++) {
              let id_cuenta = "cliente" + cuentas[i].id;
              let razon_social = cuentas[i].id + " - " + cuentas[i].razon_social;
              let sectores = cuentas[i].sectores
                ? esArray(cuentas[i].sectores.sector)
                : [];
              let cuentas_parametros = cuentas[i].parametros
                ? esArray(cuentas[i].parametros)
                : [];
              listCajasCont.push({
                id: id_cuenta,
                hierarchy: [id_cuenta],
                clienteName: razon_social,
              });
              // Bucle de sectores
              for (let i2 = 0; i2 < sectores.length; i2++) {
                let id_sector = "sector" + sectores[i2].id;
                let descripcion_sector = sectores[i2].id + " - " + sectores[i2].descripcion;
                let cajas = sectores[i2].cajas
                  ? esArray(sectores[i2].cajas.caja)
                  : [];
                listCajasCont.push({
                  id: id_sector,
                  hierarchy: [id_cuenta, id_sector],
                  sectorName: descripcion_sector,
                  cliente: eliminarValoresEntreParentesis(razon_social),
                  sector: eliminarValoresEntreParentesis(descripcion_sector),
                  id_sector: sectores[i2].id,
                  proceso_seleccionado: proceso_seleccionado
                });

                //Bucle Cajas
                for (let i3 = 0; i3 < cajas.length; i3++) {
                  const idCajaConcat = "ID: " + cajas[i3].id;
                  const referenciaCajaConcat = typeof cajas[i3].referencia === 'object' ? '' : " | Nro Ant.: " + cajas[i3].referencia;
                  let cajaConcat = idCajaConcat + referenciaCajaConcat;
                  let contenidosCaja = esArray(cajas[i3].contenidos);
                  const ubicacionTemporalEsVacia = Object.keys(cajas[i3].ubicacion_temporal).length === 0;
                  listCajasCont.push({
                    id_cuentas_localizaciones: sectores[i2].id,
                    cuentas_parametros: cuentas_parametros,
                    modelo_padre: "caja",
                    id: cajas[i3].id,
                    id_cuentas: cajas[i3].id_cuentas,
                    concatCaja: cajaConcat,
                    referencia: typeof (cajas[i3].referencia) === 'object' ? '' : cajas[i3].referencia,
                    deposito: cajas[i3].deposito,
                    ubicacion: cajas[i3].ubicacion,
                    tipo_cajas: cajas[i3].tipo_cajas,
                    fecha_creacion: cajas[i3].fecha_creacion,
                    hierarchy: [id_cuenta, id_sector, cajas[i3].id],
                    estados_cajas: cajas[i3].estado,
                    isRowSelectable: true,
                    estado: cajas[i3].estado,
                    caja: cajas[i3].id,
                    contenidos: contenidosCaja,
                    proceso_seleccionado: proceso_seleccionado,
                    excedida: cajas[i3].excedida,
                    deformada: cajas[i3].deformada,
                    id_caja_edit: cajas[i3].id,
                    contenidos_coincidencias: cajas[i3].contenidos_coincidencias,
                    detalle: cajas[i3].detalle,
                    id_tipo_caja: cajas[i3].id_tipo_caja,
                    cliente: eliminarValoresEntreParentesis(razon_social),
                    sector: eliminarValoresEntreParentesis(descripcion_sector),
                    ubicacion_temporal: ubicacionTemporalEsVacia ? "" : cajas[i3].ubicacion_temporal,
                  });
                }
              }
            }

            const reporte = convertirSectoresAArray(response.wsResponse.cuentas);

            let result = {
              data: listCajasCont,
              total_records: response.wsResponse.total_records,
              reporte: reporte,
              status: response.status,
              id_cajas: response.wsResponse.id_cajas,
              cajasId: cajasId
            };
            if (response.wsResponse.custom_counters) {
              result["custom_counters"] = response.wsResponse.custom_counters;
              result["id_contenidos"] = contenidosId;
            }
            if (response.wsResponse.custom_counters_filtered) {
              result["custom_counters_filtered"] = response.wsResponse.custom_counters_filtered;
            }
            return result;
          }
        } else {
          let result = {
            data: [],
            total_records: 0,
            reporte: {},
            status: 'false',
            id_cajas: ''
          };

          return result;

        }
      } catch (error) {
        let result = {
          data: [],
          total_records: 0,
          reporte: {}
        };
        return result;
      }
      // ---------------------------------------------------------------------------------------------------------------
    } else {

      try {
        const response = await contenidos.searchContenidosPrincipal(
          data,
          limit,
          offset,
          ordenamiento
        );

        if (response.wsResponse.cuentas) {
          let cuentas = esArray(response.wsResponse.cuentas.cuenta);
          if (response.wsResponse.id_contenidos) {
            let contenidosId;
            if (Object.keys(response.wsResponse.id_contenidos?.id).length === 0) {
              contenidosId = [];
            } else {
              // eslint-disable-next-line no-unused-vars
              contenidosId = esArray(response.wsResponse.id_contenidos.id);
            }
          }

          let cajasId = [];
          if (response.wsResponse.id_cajas) {
            cajasId = response.wsResponse.id_cajas.split(',').map(id => parseInt(id, 10));
          } else {
            cajasId = [];
          }

          if (cuentas) {
            let listCajasCont = [];
            // Bucle de cuentas
            for (let i = 0; i < cuentas.length; i++) {

              let razon_social = cuentas[i].id + " - " + cuentas[i].razon_social;
              let sectores = cuentas[i].sectores
                ? esArray(cuentas[i].sectores.sector)
                : [];
              let cuentas_parametros = cuentas[i].parametros
                ? esArray(cuentas[i].parametros)
                : [];
              // Bucle de sectores
              for (let i2 = 0; i2 < sectores.length; i2++) {

                let descripcion_sector = sectores[i2].id + " - " + sectores[i2].descripcion;
                let cajas = sectores[i2].cajas
                  ? esArray(sectores[i2].cajas.caja)
                  : [];

                //Bucle Cajas
                for (let i3 = 0; i3 < cajas.length; i3++) {
                  const idCajaConcat = "ID: " + cajas[i3].id;
                  const referenciaCajaConcat = typeof cajas[i3].referencia === 'object' ? '' : " | Nro Ant.: " + cajas[i3].referencia;
                  let cajaConcat = idCajaConcat + referenciaCajaConcat;
                  let contenidosCaja = esArray(cajas[i3].contenidos);
                  const ubicacionTemporalEsVacia = Object.keys(cajas[i3].ubicacion_temporal).length === 0;
                  listCajasCont.push({
                    id_cuentas_localizaciones: sectores[i2].id,
                    cuentas_parametros: cuentas_parametros,
                    modelo_padre: "caja",
                    id: cajas[i3].id,
                    id_cuentas: cajas[i3].id_cuentas,
                    concatCaja: cajaConcat,
                    referencia: typeof (cajas[i3].referencia) === 'object' ? '' : cajas[i3].referencia,
                    deposito: cajas[i3].deposito,
                    ubicacion: cajas[i3].ubicacion,
                    tipo_cajas: cajas[i3].tipo_cajas,
                    fecha_creacion: cajas[i3].fecha_creacion,
                    hierarchy: [cajas[i3].id],
                    estados_cajas: cajas[i3].estado,
                    isRowSelectable: true,
                    estado: cajas[i3].estado,
                    caja: cajas[i3].id,
                    contenidos: contenidosCaja,
                    proceso_seleccionado: proceso_seleccionado,
                    excedida: cajas[i3].excedida,
                    deformada: cajas[i3].deformada,
                    id_caja_edit: cajas[i3].id,
                    contenidos_coincidencias: cajas[i3].contenidos_coincidencias,
                    detalle: cajas[i3].detalle,
                    id_tipo_caja: cajas[i3].id_tipo_caja,
                    cliente: eliminarValoresEntreParentesis(razon_social),
                    sector: eliminarValoresEntreParentesis(descripcion_sector),
                    clienteName: razon_social,
                    sectorName: descripcion_sector,
                    ubicacion_temporal: ubicacionTemporalEsVacia ? "" : cajas[i3].ubicacion_temporal,

                  });
                }
              }
            }

            const reporte = convertirSectoresAArray(response.wsResponse.cuentas);

            let result = {
              data: listCajasCont,
              total_records: response.wsResponse.total_records,
              reporte: reporte,
              status: response.status,
              id_cajas: response.wsResponse.id_cajas,
              cajasId: cajasId
            };
            if (response.wsResponse.custom_counters) {
              result["custom_counters"] = response.wsResponse.custom_counters;
              result["id_contenidos"] = contenidosId;
            }
            if (response.wsResponse.custom_counters_filtered) {
              result["custom_counters_filtered"] = response.wsResponse.custom_counters_filtered;
            }
            return result;
          }
        } else {
          let result = {
            data: [],
            total_records: 0,
            reporte: {},
            status: 'false',
            id_cajas: ''
          };

          return result;

        }
      } catch (error) {
        let result = {
          data: [],
          total_records: 0,
          reporte: {}
        };
        return result;
      }

    }
  }


};

export const getProcesosGeneralesContenidosSearchPaginated = async (limit, offset, data, ordenamiento) => {
  if (Array.isArray(data)) {
    // eslint-disable-next-line no-unused-vars
    let data = {
      coincidencias: "1",
      eliminados: "0",
      search_params: {},
      limit: limit,
      offset: offset,
    };
  }
  const contenidos = new datos("contenidos");
  try {
    const devuelveContenidos = true;
    const response = await contenidos.searchContenidosPrincipal(
      data,
      limit,
      offset,
      ordenamiento,
      devuelveContenidos,
    );

    if (response.wsResponse.cuentas) {
      var cuentas = esArray(response.wsResponse.cuentas.cuenta);
      if (response.wsResponse.id_contenidos) {
        if (Object.keys(response.wsResponse.id_contenidos?.id).length === 0) {
          var contenidosId = [];
        } else {
          contenidosId = esArray(response.wsResponse.id_contenidos.id);
        }
      }

      localStorage.setItem('id_contenidos', contenidosId)
      if (cuentas) {
        var listCajasCont = [];
        // Bucle de cuentas
        for (let i = 0; i < cuentas.length; i++) {
          let sectores = cuentas[i].sectores
            ? esArray(cuentas[i].sectores.sector)
            : [];
          // Bucle de sectores
          for (let i2 = 0; i2 < sectores.length; i2++) {
            let cajas = sectores[i2].cajas
              ? esArray(sectores[i2].cajas.caja)
              : [];
            //Bucle Cajas
            for (let i3 = 0; i3 < cajas.length; i3++) {
              const idCajaConcat = "ID: " + cajas[i3].id;
              const referenciaCajaConcat = typeof cajas[i3].referencia === 'object' ? '' : " | Nro Ant.: " + cajas[i3].referencia;
              let cajaConcat = idCajaConcat + referenciaCajaConcat;
              let contenidosCaja = esArray(cajas[i3].contenidos);
              for (let i4 = 0; i4 < contenidosCaja.length; i4++) {
                let contenidosMetadatos = contenidosCaja[i4]?.contenidos_metadatos ? esArray(contenidosCaja[i4].contenidos_metadatos) : [];
                const objetoResultado = {};
                for (let i5 = 0; i5 < contenidosMetadatos.length; i5++) {
                  contenidosMetadatos.forEach(dato => {
                    const propiedad = dato.metadato_label_grilla;
                    const valor = `${dato.metadato_label_form} | ${dato.metadato_valor}`;
                    objetoResultado[propiedad] = valor
                  });
                }
                listCajasCont.push({
                  // modelo_padre: "caja",
                  ...objetoResultado,
                  id_caja: cajas[i3].id,
                  id_cuentas: cajas[i3].id_cuentas,
                  id_sector: sectores[i2].id,
                  concatCaja: cajaConcat,
                  referencia_caja: typeof (cajas[i3].referencia) === 'object' ? '' : cajas[i3].referencia,
                  deposito_caja: cajas[i3].deposito,
                  ubicacion_caja: cajas[i3].ubicacion,
                  tipo_cajas: cajas[i3].tipo_cajas,
                  fecha_creacion_caja: cajas[i3].fecha_creacion,
                  estados_cajas: cajas[i3].estado,
                  isRowSelectable: true,
                  estado_caja: cajas[i3].estado,
                  estado_contenido: contenidosCaja[i4].estado,
                  id: contenidosCaja[i4].id
                });



              }
            }
          }
        }
        let result = {
          data: listCajasCont,
          total_records: listCajasCont.length === 0 ? 0 : response.wsResponse.total_records,
          reporte: response.wsResponse.cuentas,
        };
        if (response.wsResponse.custom_counters) {
          result["custom_counters"] = response.wsResponse.custom_counters;
          result["id_contenidos"] = contenidosId;
        }
        return result;
      }
    } else {
      let result = {
        data: [],
        total_records: 0,
        reporte: {}
      };

      return result;

    }
  } catch (error) {
    let result = {
      data: [],
      total_records: 0,
      reporte: {}
    };
    return result;
    // Aquí puedes manejar el error de manera adecuada, por ejemplo, mostrando un mensaje al usuario
  }
};

export const replaceObjectWithNull = function (array) {
  return array.map((item) => {
    if (typeof item.metadato_valor === 'object') {
      return {
        ...item,
        metadato_valor: "",
      };
    }
    return item;
  });
};


export const getSearchContenidos = async (data) => {
  if (Array.isArray(data)) {
    // eslint-disable-next-line no-unused-vars
    let data = {
      coincidencias: "1",
      eliminados: "0",
      search_params: {},
    };
  }
  const contenidos = new datos("contenidos");
  const response = await contenidos.searchContenidosPrincipal(data);
  if (response.status === "true") {
    let listContenidos = esArray(response.wsResponse.contenidos?.contenido);
    for (let i = 0; i < listContenidos.length; i++) {
      let arrMetaDatos = esArray(listContenidos[i].contenidos_metadatos);
      listContenidos[i].isRowSelectable = true;

      listContenidos[i].contenidos_metadatos_ordenados = concatenarContenidos(arrMetaDatos)
      listContenidos[i].arrayMetaDatos = replaceObjectWithNull(arrMetaDatos);

    }
    let result = {
      data: listContenidos,
      total_records: listContenidos.length,
    };
    return result;
  } else {
    let result = {
      data: [],
      total_records: [].length,
    };
    return result;
  }

}




export const getInformeMovimientosSearchPaginated = async (
  limit,
  offset,
  data
) => {
  if (Array.isArray(data)) {
    // eslint-disable-next-line no-unused-vars
    let data = { coincidencias: "1", eliminados: "0", search_params: {} };
  }
  const contenidos = new datos("contenidos");


  try {
    const response = await contenidos.searchContenidosPrincipal(data, limit, offset);

    if (response.wsResponse.cajas?.clientes) {
      var cont = esArray(response.wsResponse.cajas.clientes);
      cont = Object.values(cont);
      var listClientesCont = [];
      if (cont) {
        for (let i = 0; i < cont.length; i++) {
          listClientesCont.push({
            id: "cliente" + cont[i].id_cuentas,
            cliente: cont[i].id_cuentas + " - " + cont[i].nombre,
            hierarchy: ["cliente" + cont[i].id_cuentas],
          });

          var sec = esArray(cont[i].sectores);
          for (let i2 = 0; i2 < sec.length; i2++) {
            listClientesCont.push({
              id: "sector" + sec[i2].id_cuentas_localizaciones,
              sector:
                sec[i2].id_cuentas_localizaciones + " - " + sec[i2].descripcion,
              hierarchy: [
                "cliente" + cont[i].id_cuentas,
                "sector" + sec[i2].id_cuentas_localizaciones,
              ],
            });
            var caja = esArray(sec[i2].cajas);
            for (let i3 = 0; i3 < caja.length; i3++) {
              listClientesCont.push({
                id: "caja" + caja[i3].id,
                cajas: caja[i3].id,
                ubicacion: caja[i3].ubicacion,
                tipo_cajas: caja[i3].tipo_cajas,
                historico: caja[i3].historico,
                hierarchy: [
                  "cliente" + cont[i].id_cuentas,
                  "sector" + sec[i2].id_cuentas_localizaciones,
                  "caja" + caja[i3].id,
                ],
              });
              var contenido = esArray(caja[i3].contenidos);
              for (let i4 = 0; i4 < contenido.length; i4++) {
                var metadatos = contenido[i4].contenidos_metadatos;
                let meta_valor = concatenarContenidos(metadatos);

                listClientesCont.push({
                  id: "contendios" + contenido[i4].id,
                  contenidos: meta_valor,
                  HistoricoContenidos: contenido[i4].historico,
                  hierarchy: [
                    "cliente" + cont[i].id_cuentas,
                    "sector" + sec[i2].id_cuentas_localizaciones,
                    "caja" + caja[i3].id,
                    "contendios" + contenido[i4].id,
                  ],
                });
              }
            }
          }
        }
        let result = {
          data: listClientesCont,
          total_records: response.wsResponse.total_records,
        };
        return result;
      }
    }
    // Hacer algo con la respuesta, por ejemplo, actualizar el estado del componente
  } catch (error) {
    let result = {
      data: [],
      total_records: 0,
    };
    return result;
    // Aquí puedes manejar el error de manera adecuada, por ejemplo, mostrando un mensaje al usuario
  }


};

export const getInformeSearchPaginated = async (limit, offset, data) => {
  if (Array.isArray(data)) {
    // eslint-disable-next-line no-unused-vars
    let data = { coincidencias: "1", eliminados: "0", search_params: {} };
  }
  const contenidos = new datos("contenidos");

  const response = await contenidos.searchContenidosPrincipal(data);

  var cantContenidos = 0;
  if (response.wsResponse.cajas) {
    var cont = esArray(response.wsResponse.cajas);
    var listCajasCont = [];
    if (cont) {
      for (let i = 0; i < cont.length; i++) {
        for (let i2 = 0; i2 < cont[i].caja.length; i2++) {
          //NOTE PUSHEO LOS DATOS DE LA CAJA
          listCajasCont.push({
            id: cont[i].caja[i2].id,
            fecha_creacion: cont[i].caja[i2].fecha_creacion,
            cliente: cont[i].caja[i2].cliente,
            ubicacion: cont[i].caja[i2].ubicacion,
            deposito: cont[i].caja[i2].deposito,
            contenidos: [],
          });

          //NOTE ENTRA ACA CUANDO VIENEN CONTENIDOS EN UN ARRAY DATOS DE CONTENIDOS
          if (cont[i].caja[i2].contenidos.length > 0) {
            for (let i3 = 0; i3 < cont[i].caja[i2].contenidos.length; i3++) {
              var datosCont =
                cont[i].caja[i2].contenidos[i3].contenidos_metadatos;
              const contenidosConcatenados = concatenarContenidos(datosCont);
              cont[i].caja[i2].contenidosConcat = contenidosConcatenados;
              listCajasCont[i2].contenidos.push({
                id: cont[i].caja[i2].contenidos[i3].id,
                id_caja: cont[i].caja[i2].id,
                contenidoConcat:
                  cont[i].caja[i2].contenidosConcat +
                  "| ESTADO: " +
                  cont[i].caja[i2].contenidos[i3].estado,
              });
              cantContenidos = cantContenidos + 1;
            }
          } else {
            //NOTE ENTRA ACA CUANDO VIENEN CONTENIDOS EN UN OBJETO DATOS DE CONTENIDOS
            const contenidosConcatenados = concatenarContenidos(
              cont[i].caja[i2].contenidos.contenidos_metadatos
            );

            listCajasCont[i2].contenidos.push({
              id: 0,
              id_caja: cont[i].caja[i2].id,
              contenidoConcat:
                contenidosConcatenados +
                "| ESTADO: " +
                cont[i].caja[i2].contenidos.estado,
            });
          }
        }
      }
      let result = {
        data: listCajasCont,
        total_records: listCajasCont.length,
      };
      return result;
    }
  } else {
    return { data: [], total_records: 0 };
  }
};

/// Funcion que concatena el valor de los contenidos de cada caja
const concatenarContenidos = (datos) => {
  var arrMetaDatos = [];
  if (Array.isArray(datos)) {
    arrMetaDatos = datos;
    // Si no es un array... primero se verifica que tenga valores ... si no los tiene
  } else if (!datos) {
    // se pasa un array vacio
    arrMetaDatos = [];
  } else {
    // si trae un solo elemento , es un objeto
    arrMetaDatos = [datos]; // se lo convierte a array
  }

  var contenidosConcatenados = "";
  for (let i4 = 0; i4 < arrMetaDatos.length; i4++) {
    if (contenidosConcatenados === "") {
      contenidosConcatenados =
        contenidosConcatenados +
        arrMetaDatos[i4].metadato_label_form +
        ": " +
        arrMetaDatos[i4].metadato_valor;
    } else {
      contenidosConcatenados =
        contenidosConcatenados +
        " | " +
        arrMetaDatos[i4].metadato_label_form +
        ": " +
        arrMetaDatos[i4].metadato_valor;
    }
  }
  return contenidosConcatenados;
};

export const getCajasSearchPaginated = async (limit, offset, data) => {
  if (Array.isArray(data)) {
    // eslint-disable-next-line no-unused-vars
    let data = { coincidencias: "1", eliminados: "0", search_params: {} };
  }
  const contenidos = new datos("contenidos");
  const response = await contenidos.searchContenidosPrincipal(data);

  // eslint-disable-next-line no-unused-vars
  var cantContenidos = 0;
  if (response.wsResponse.cajas) {
    var cont = esArray(response.wsResponse.cajas);
    var listCajasCont = [];
    if (cont) {
      for (let i = 0; i < cont.length; i++) {
        // Si es un array se mantiene como estaba
        if (Array.isArray(cont[i].caja)) {
          // eslint-disable-next-line no-self-assign
          cont[i].caja = cont[i].caja;
          // Si no es un array... primero se verifica que tenga valores ... si no los tiene
        } else if (!cont[i].caja) {
          // se pasa un array vacio
          cont[i].caja = [];
        } else {
          // si trae un solo elemento , es un objeto
          cont[i].caja = [cont[i].caja]; // se lo convierte a array
        }
        for (let i2 = 0; i2 < cont[i].caja.length; i2++) {
          let ref = cont[i].caja[i2].referencia;
          cont[i].cajaConcat =
            "ID: " +
            cont[i].caja[i2].id +
            " | " +
            "DETALLE: " +
            cont[i].caja[i2].detalle;
          cont[i].caja[i2].contenidos2 = cont[i].caja[i2].contenidos;
          if (typeof ref !== "object" && ref !== "") {
            cont[i].cajaConcat =
              cont[i].cajaConcat +
              " | " +
              "REFERENCIA: " +
              cont[i].caja[i2].referencia;
          }
          listCajasCont.push({
            id: cont[i].caja[i2].id,
            referencia: typeof (cont[i].caja[i2].referencia) === 'object' ? '' : cont[i].caja[i2].referencia,
            detalle: cont[i].caja[i2].detalle,
            fecha_creacion: cont[i].caja[i2].fecha_creacion,
            cliente: cont[i].caja[i2].cliente,
          });
        }
      }
      let result = {
        data: listCajasCont,
        total_records: listCajasCont.length,
      };
      return result;
    }
  }
};


export const getDigitalizacionesContenidos = async (idContenido) => {
  const contenidos = new datos("digitalizaciones");
  contenidos.addCondition(
    "digitalizaciones",
    "id_contenidos",
    idContenido,
    "="
  );
  contenidos.join("digitalizaciones_metadatos", "id_digitalizaciones", "id", "=");
  contenidos.innerJoinTables('metadatos', 'digitalizaciones_metadatos', "id", "id_metadatos", "=")
  const response = await contenidos.get();
  if (response.status === "true") {
    return esArray(response.wsResponse.digitalizaciones);
  } else {
    return response;
  }
};

export const getImages = async (data) => {
  const contenidos = new datos("contenidos");
  const response = await contenidos.getImages(data);
  if (response.status === "true") {
    return esArray(response.wsResponse.imagenes);
  } else {
    return [];
  }
};


export const getContenidosPaginatedDashboard = async (limit, offset, conditions) => {
  const { idLocalizaciones, inputSearch, soloCajas, ubicaciones, cajas, estados_cajas, devuelveContenidos, busqueda_digitalizaciones, custom_query } = conditions;
  const { input_general, input_numerico, input_numero_desde, input_numero_hasta, input_fecha, input_fecha_desde, input_fecha_hasta } = inputSearch;

  const data_conditions = {
    "id_cuentas_localizaciones": idLocalizaciones?.toString() ?? "",
    "valor_contenido": input_general?.toString() ?? "",
    "valor_numero": input_numerico?.toString() ?? "",
    "valor_numero_desde": input_numero_desde?.toString() ?? "",
    "valor_numero_hasta": input_numero_hasta?.toString() ?? "",
    "valor_fecha": input_fecha?.toString() ?? "",
    "valor_fecha_desde": input_fecha_desde?.toString() ?? "",
    "valor_fecha_hasta": input_fecha_hasta?.toString() ?? "",
    "soloCajas": soloCajas ?? false,
    "devuelveContenidos": devuelveContenidos ?? false,
    "busqueda_digitalizaciones": busqueda_digitalizaciones ?? false,
    "contabilizar_estadisticas": "1",
    limit: `${limit}`,
    offset: `${offset}`,
    ...(ubicaciones ? { ubicaciones } : {}),
    ...(cajas ? { cajas } : {}),
    ...(estados_cajas ? { estados_cajas } : {}),
    ...(custom_query ? { custom_query } : {}),
  };


  const objectContenidos = new datos("contenidos");
  const response = await objectContenidos.searchDashboard(data_conditions);

  if (!response) {
    return { data: [], total_records: 0, sin_jerarquia: true };
  }

  let cajasId = [];
  if (response.wsResponse.id_cajas && response.wsResponse.id_cajas !== '' && typeof response.wsResponse.id_cajas !== "object") {
    cajasId = response.wsResponse.id_cajas.split(',').map(id => String(id));
  } else {
    cajasId = [];
  }
  const soloCajasNum = Number(soloCajas);


  if (soloCajasNum ? response.wsResponse.cajas : response.wsResponse.contenidos) {

    const contenidosRaw = esArray(soloCajasNum ? response.wsResponse.cajas : response.wsResponse.contenidos);
    const contenidosData = agregarPropiedades(contenidosRaw, response.wsResponse.digitalizaciones_coincidencias || '');
    let result = {
      data: contenidosData,
      total_records: response.wsResponse.total_records,
      sin_jerarquia: true,
      status: true,
      cajasId: cajasId,
      id_cajas: response.wsResponse.id_cajas || '',
      id_contenidos: response.wsResponse.id_contenidos || '',
      digitalizaciones_coincidencias: response.wsResponse.digitalizaciones_coincidencias || '',
    };

    if (response.wsResponse.custom_counters) {
      result["custom_counters"] = response.wsResponse.custom_counters;
    }

    if (response.wsResponse.custom_counters_filtered) {
      result["custom_counters_filtered"] = response.wsResponse.custom_counters_filtered;
    }

    return result;

  } else {
    let result = {
      data: [],
      total_records: 0,
      sin_jerarquia: true
    };
    return result;
  }
};

function agregarPropiedades(arr, digitalizaciones_coincidencias = '') {
  return arr.map(item => {
    const { cliente, sector, referencia, ubicacion_temporal, contenidos_metadatos, parametros, id, id_tipo_cajas, estado_caja } = item;

    // Limpiar cliente y sector
    const clienteName = cliente.replace(/\s-\s\(\d+\)\s*$/, "");
    const sectorName = sector.replace(/\s-\s\(\d+\)\s*$/, "");

    // Verificar si los objetos están vacíos
    const referenciaEsVacia = !referencia || Object.keys(referencia).length === 0;
    const ubicacionTemporalEsVacia = !ubicacion_temporal || Object.keys(ubicacion_temporal).length === 0;

    // Obtener array de metadatos seguro
    const metadatos = esArray(contenidos_metadatos?.metadato);

    // Construir objeto de metadatos
    const objetoResultado = metadatos.reduce((acc, dato) => {
      const propiedad = dato.label_grilla.toLowerCase();
      const valor = `${dato.label_form} | ${dato.valor}`;

      // Concatenar si ya existe
      acc[propiedad] = acc[propiedad] ? `${acc[propiedad]} || ${valor}` : valor;
      return acc;
    }, {});

    return {
      ...item,
      ...objetoResultado,
      clienteName,
      sectorName,
      concatCaja: referenciaEsVacia ? `ID: ${id}` : `ID: ${id} | Nro Ant.: ${referencia}`,
      tipo_cajas: id_tipo_cajas,
      estados_cajas: estado_caja,
      cuentas_parametros: esArray(parametros),
      id_caja_edit: id,
      id_tipo_caja: id_tipo_cajas,
      isRowSelectable: true,
      digitalizaciones_coincidencias,
      ubicacion_temporal: ubicacionTemporalEsVacia ? '' : ubicacion_temporal,
    };
  });
}


export const getContenidosSearchPaginatedSoloContenidos = async (limit, offset, data, ordenamiento) => {
  let proceso_seleccionado = JSON.parse(localStorage.getItem("proceso_seleccionado"));
  if (Array.isArray(data)) {
    // eslint-disable-next-line no-unused-vars
    let data = {
      coincidencias: "1",
      eliminados: "0",
      search_params: {},
      limit: limit,
      offset: offset,

    };
  }
  const contenidos = new datos("contenidos");

  if (data.busqueda_simple) {

    const datos_search = {
      idLocalizaciones: data?.search_params?.busqueda_simple?.ids_cuentas_localizaciones ?? [],
      inputSearch: data?.search_params?.busqueda_simple?.data ?? '',
      soloCajas: false,
      devuelveContenidos: data?.devuelveContenidos ?? false,
    };

    if (data?.search_params?.ubicaciones) {
      datos_search.ubicaciones = data.search_params.ubicaciones;
    }

    if (data?.search_params?.cajas) {
      datos_search.cajas = data.search_params.cajas;
    }

    if (data?.search_params?.estados_cajas) {
      datos_search.estados_cajas = data.search_params.estados_cajas;
    }

    if (data?.search_params?.custom_query) {
      datos_search.custom_query = data.search_params.custom_query;
    }

    let response = await getContenidosPaginatedDashboard(limit, offset, datos_search);

    const data_array = agregarPropiedades(response.data, response.digitalizaciones_coincidencias);

    response.data = data_array;


    return response;

  } else {

    const data_conditions = {
      ...data,
      soloCajas: '0', // Asigna 'false' si soloCajas es undefined o null
      devuelveContenidos: '1', // Asigna 'false' si devuelveContenidos es undefined o null
    }



    // ---------------------------------------------------------------------------------------------------------------


    try {
      const response = await contenidos.searchContenidosPrincipal(
        data_conditions,
        limit,
        offset,
        ordenamiento
      );

      if (response.wsResponse.cuentas) {

        if (response.wsResponse.id_contenidos) {
          if (Object.keys(response.wsResponse.id_contenidos?.id).length === 0) {
            var contenidosId = [];
          } else {
            contenidosId = esArray(response.wsResponse.id_contenidos.id);
          }
        }
        let cuentas = esArray(response.wsResponse.cuentas.cuenta);
        if (response.wsResponse.id_contenidos) {
          let contenidosId;
          if (Object.keys(response.wsResponse.id_contenidos?.id).length === 0) {
            contenidosId = [];
          } else {
            // eslint-disable-next-line no-unused-vars
            contenidosId = esArray(response.wsResponse.id_contenidos.id);
          }
        }
        if (cuentas) {
          let listCajasCont = [];
          // Bucle de cuentas
          for (let i = 0; i < cuentas.length; i++) {

            let razon_social = cuentas[i].id + " - " + cuentas[i].razon_social;
            let sectores = cuentas[i].sectores
              ? esArray(cuentas[i].sectores.sector)
              : [];
            let cuentas_parametros = cuentas[i].parametros
              ? esArray(cuentas[i].parametros)
              : [];
            // Bucle de sectores
            for (let i2 = 0; i2 < sectores.length; i2++) {

              let descripcion_sector = sectores[i2].id + " - " + sectores[i2].descripcion;
              let cajas = sectores[i2].cajas
                ? esArray(sectores[i2].cajas.caja)
                : [];

              //Bucle Cajas
              for (let i3 = 0; i3 < cajas.length; i3++) {
                const idCajaConcat = "ID: " + cajas[i3].id;
                const referenciaCajaConcat = typeof cajas[i3].referencia === 'object' ? '' : " | Nro Ant.: " + cajas[i3].referencia;
                let cajaConcat = idCajaConcat + referenciaCajaConcat;
                let contenidosCaja = esArray(cajas[i3].contenidos);
                listCajasCont.push({
                  id_cuentas_localizaciones: sectores[i2].id,
                  cuentas_parametros: cuentas_parametros,
                  modelo_padre: "caja",
                  id: cajas[i3].id,
                  id_cuentas: cajas[i3].id_cuentas,
                  concatCaja: cajaConcat,
                  referencia: typeof (cajas[i3].referencia) === 'object' ? '' : cajas[i3].referencia,
                  deposito: cajas[i3].deposito,
                  ubicacion: cajas[i3].ubicacion,
                  tipo_cajas: cajas[i3].tipo_cajas,
                  fecha_creacion: cajas[i3].fecha_creacion,
                  hierarchy: [cajas[i3].id],
                  estados_cajas: cajas[i3].estado,
                  isRowSelectable: true,
                  estado: cajas[i3].estado,
                  caja: cajas[i3].id,
                  contenidos: contenidosCaja,
                  proceso_seleccionado: proceso_seleccionado,
                  excedida: cajas[i3].excedida,
                  deformada: cajas[i3].deformada,
                  id_caja_edit: cajas[i3].id,
                  contenidos_coincidencias: cajas[i3].contenidos_coincidencias,
                  detalle: cajas[i3].detalle,
                  id_tipo_caja: cajas[i3].id_tipo_caja,
                  cliente: eliminarValoresEntreParentesis(razon_social),
                  sector: eliminarValoresEntreParentesis(descripcion_sector),
                  clienteName: razon_social,
                  sectorName: descripcion_sector,
                  numero: "-",
                  texto: "-",
                  fecha: "-",
                  numero_desde: "-",
                  numero_hasta: "-",
                  fecha_desde: "-",
                  fecha_hasta: "-",


                });
              }
            }
          }

          const reporte = convertirSectoresAArray(response.wsResponse.cuentas);

          const listado_aplanado = aplanarContenidos(listCajasCont);
          const data_array = agregarPropiedadesSearch(listado_aplanado, listado_aplanado.digitalizaciones_coincidencias);
          let result = {
            data: data_array,
            total_records: response.wsResponse.total_records,
            reporte: reporte,
            status: response.status,
            id_cajas: response.wsResponse.id_cajas
          };
          if (response.wsResponse.custom_counters) {
            result["custom_counters"] = response.wsResponse.custom_counters;
            result["id_contenidos"] = contenidosId;
          }
          return result;
        }
      } else {
        let result = {
          data: [],
          total_records: 0,
          reporte: {},
          status: 'false',
          id_cajas: ''
        };

        return result;

      }
    } catch (error) {
      let result = {
        data: [],
        total_records: 0,
        reporte: {}
      };
      return result;
    }


  }


};


function aplanarContenidos(array) {
  const resultado = [];

  array.forEach(objetoPadre => {
    const { contenidos, id: id_caja, estado: estado_caja, ...restoPadre } = objetoPadre;

    contenidos.forEach(contenido => {
      resultado.push({
        ...contenido,
        estado_contenido: contenido.estado,
        id_caja,           // conservamos el ID del padre con otro nombre
        estado_caja,
        ...restoPadre       // agregamos otras propiedades del padre (como sector)
      });
    });
  });

  return resultado;
}


function agregarPropiedadesSearch(arr, digitalizaciones_coincidencias) {
  return arr.map(item => {
    const clienteName = item.cliente.replace(/\s-\s\(\d+\)\s*$/, "");
    const sectorName = item.sector.replace(/\s-\s\(\d+\)\s*$/, "");
    const referenciaEsVacia = Object.keys(item.referencia).length === 0;
    let contenidosMetadatos = item?.contenidos_metadatos ? esArray(item.contenidos_metadatos) : [];

    const objetoResultado = {};

    contenidosMetadatos.forEach(dato => {
      const propiedad = dato.metadato_label_grilla.toLowerCase();
      const valor = `${dato.metadato_label_form} | ${dato.metadato_valor}`;

      // Concatenar si ya existe, si no crear
      if (objetoResultado[propiedad]) {
        objetoResultado[propiedad] += ` || ${valor}`;
      } else {
        objetoResultado[propiedad] = valor;
      }
    });

    return {
      ...item,
      ...objetoResultado,
      clienteName,
      sectorName,
      concatCaja: referenciaEsVacia ? `ID: ${item.id}` : `ID: ${item.id} | Nro Ant.: ${item.referencia}`,
      tipo_cajas: item.id_tipo_cajas,
      estados_cajas: item.estado_caja,
      cuentas_parametros: item.parametros ? esArray(item.parametros) : [],
      id_caja_edit: item.id,
      id_tipo_caja: item.id_tipo_cajas,
      isRowSelectable: true,
      digitalizaciones_coincidencias: digitalizaciones_coincidencias || '',
    };
  });
}

export const getAllDataForExport = async (idElementData, fileType = 'Excel', meta = {}) => {
  const clientData = JSON.parse(localStorage.getItem("clientData") || "{}");
  const userData   = JSON.parse(localStorage.getItem("siam-user-data") || "{}");

  const dominio = clientData.dominio?.replace(/\/$/, '') || '';
  if (!dominio) throw new Error('No se encontró la URL del servidor');

  const body = JSON.stringify({
    "@name": "contenidos",
    ws_structure: {
      params: { ...idElementData, contabilizar_estadisticas: '0', devuelveContenidos: '1' },
      export_meta: meta,
    },
    authorization: {
      owner_code: clientData.owner_code || '',
      id_user:    userData.id || '',
      language:   'es',
    },
  });

  const endpointUrl = fileType === 'JSON'
    ? endpoints.urls.contenidosExportJson
    : fileType === 'CSV'
      ? endpoints.urls.contenidosExportCsv
      : endpoints.urls.contenidosExportXlsx;

  const response = await fetch(dominio + endpointUrl, {
    method:  'POST',
    headers: headers(),
    body,
  });

  if (!response.ok) throw new Error(`Error del servidor (${response.status})`);

  // Todos los formatos devuelven JSON con {url, filename} — mismo path unificado.
  const json = await response.json();
  if (!json.url) throw new Error('Error al exportar: respuesta inesperada del servidor');
  // Normalizar el scheme para evitar bloqueos mixed-content cuando el servidor
  // está detrás de un proxy HTTPS y devuelve una URL http://.
  const downloadUrl = json.url.replace(/^http:\/\//i, window.location.protocol + '//');
  const a = document.createElement('a');
  a.href = downloadUrl;
  a.download = json.filename || `${meta.titulo || 'procesos_general'}_${new Date().toISOString().slice(0, 10)}`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  return null;
};

export const getExportXlsxCount = async (idElementData) => {
  const clientData = JSON.parse(localStorage.getItem("clientData") || "{}");
  const userData   = JSON.parse(localStorage.getItem("siam-user-data") || "{}");

  const dominio = clientData.dominio?.replace(/\/$/, '') || '';
  if (!dominio) throw new Error('No se encontró la URL del servidor');

  const body = JSON.stringify({
    "@name": "contenidos",
    ws_structure: {
      params: { ...idElementData, contabilizar_estadisticas: '0', devuelveContenidos: '1' },
    },
    authorization: {
      owner_code: clientData.owner_code || '',
      id_user:    userData.id || '',
      language:   'es',
    },
  });

  const response = await fetch(dominio + endpoints.urls.contenidosCountXlsx, {
    method:  'POST',
    headers: headers(),
    body,
  });
  if (!response.ok) throw new Error(`Error al contar registros (${response.status})`);
  return await response.json(); // { count: N }
};

export const getCajasSinContenidos = async (idElementData) => {
  const clientData = JSON.parse(localStorage.getItem("clientData") || "{}");
  const userData   = JSON.parse(localStorage.getItem("siam-user-data") || "{}");
  const dominio = clientData.dominio?.replace(/\/$/, '') || '';
  if (!dominio) throw new Error('No se encontró la URL del servidor');

  const body = JSON.stringify({
    "@name": "contenidos",
    ws_structure: {
      params: { ...idElementData, contabilizar_estadisticas: '0' },
    },
    authorization: {
      owner_code: clientData.owner_code || '',
      id_user:    userData.id || '',
      language:   'es',
    },
  });

  const response = await fetch(dominio + endpoints.urls.contenidosCajasSinContenidos, {
    method:  'POST',
    headers: headers(),
    body,
  });
  if (!response.ok) throw new Error(`Error del servidor (${response.status})`);
  return await response.json(); // { cajas: [{cliente, sector, id_caja}] }
};

export const exportCsvStream = async (data) => {
  const { dominio } = JSON.parse(localStorage.getItem("clientData"));
  const url = dominio + endpoints.urls.contenidosExportCsv;

  const response = await fetch(url, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify({
      ws_structure: {
        params: { ...data, contabilizar_estadisticas: '0' },
      },
    }),
  });

  if (!response.ok) throw new Error('Error al exportar CSV');

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = `export_${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(objectUrl);
};


